import { useEffect, useRef, useState } from "react";

// Restrained progress animation: animates from the LAST value the customer saw
// (persisted per id) to the new confirmed value, so growth feels earned. Honors
// prefers-reduced-motion by jumping straight to the final value.
export function AnimatedBar({ value = 0, id, trackClassName = "h-2.5 w-full overflow-hidden rounded-full bg-[#EADFC7]", barClassName = "h-full rounded-full bg-[#C9A86A]", testid }) {
  const target = Math.max(0, Math.min(100, Number(value) || 0));
  const key = id ? `ms_bar_${id}` : null;
  const prev = useRef(0);
  const [w, setW] = useState(target);

  useEffect(() => {
    let start = 0;
    try { if (key) start = Number(sessionStorage.getItem(key)) || 0; } catch {}
    prev.current = start;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || start === target) {
      setW(target);
    } else {
      setW(start);
      const t = setTimeout(() => setW(target), 60);
      try { if (key) sessionStorage.setItem(key, String(target)); } catch {}
      return () => clearTimeout(t);
    }
    try { if (key) sessionStorage.setItem(key, String(target)); } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, key]);

  return (
    <div className={trackClassName}>
      <div className={`${barClassName} transition-[width] duration-[900ms] ease-out`} style={{ width: `${w}%` }} data-testid={testid} />
    </div>
  );
}
